var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoverHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 69,
    viewBox: "0 0 102 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4733 46.6983L23.3498 46.6983C16.2935 46.6983 10.5666 40.9715 10.5666 33.9152C10.5666 26.8589 16.2935 21.132 23.3498 21.132L42.4733 21.132C38.3316 14.945 31.3264 10.9055 23.3498 10.9055C10.6177 10.9055 0.340086 21.1832 0.340086 33.9152C0.340087 46.6472 10.6177 56.9249 23.3498 56.9249C31.3264 56.9249 38.3316 52.8854 42.4733 46.6983ZM66.1477 -3.61613L54.5918 19.5981C54.2338 20.4673 54.0293 21.3877 54.0293 22.3592L54.0293 26.2453L23.3498 26.2453C19.1058 26.2453 15.6799 29.6712 15.6799 33.9152C15.6799 38.1592 19.1058 41.5851 23.3498 41.5851L78.2662 41.5851C74.3801 59.9928 74.4312 59.686 74.4312 60.3507C74.4312 61.9358 75.096 63.3676 76.1186 64.3902L80.2092 68.4297L105.469 43.1702C106.849 41.7896 107.719 39.8466 107.719 37.7501L107.719 3.0311C107.719 -0.803845 104.906 -3.76953 101.174 -4.33199L74.2267 -8.16693C73.8688 -8.21807 73.5108 -8.2692 73.204 -8.2692C70.0338 -8.2692 67.2727 -6.32616 66.1477 -3.61613Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverHand);
export default __webpack_public_path__ + "static/media/hover-hand.00900c8c.svg";
export { ForwardRef as ReactComponent };